module.exports = __webpack_public_path__ + "img/Japanese.c697ac43.svg";